import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useAuthorization } from '../../../services/authorization'
import { LINKS } from '../../../constants'

const PrivateRoute = ({ component, ...props }) => {
  const [getAuthToken] = useAuthorization()
  return getAuthToken() ? <Route {...props} component={component} /> : <Redirect to={LINKS.LOGIN} />
}

export default PrivateRoute
